"use strict";
import styledFn from "styled-components";
export default styledFn;
export * from "styled-components";
